import { Component, OnInit, Input, Injectable } from "@angular/core";
import { NgbInputDatepicker,NgbDatepickerI18n,NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { CommonService } from "../service/common.service";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { PersonService } from '../service/person.service';

@Component({
  selector: "yoyaku-property-model-app",
  templateUrl: "./yoyaku-property-model.component.html",
  styleUrls: ["yoyaku-property-model.component.css"],
})
export class YoyakuPropertyModelComponent {
  @Input() yoyakuData: any;

  constructor(
    public commonService: CommonService,
    public activeModal: NgbActiveModal,
    private personService: PersonService,
  ) {}
  dataList: any =[];
  isLoaded:boolean = false;
  ret: any = {
    status: "",
    selectedData: [],
  };
  //起動時処理
  ngOnInit(): void {
    this.getYoyakuProperty();
  }
  getYoyakuProperty(): void {
    let params = {
      "t_person_id": this.yoyakuData.t_person_id,
      "m_language_id": this.yoyakuData.m_language_id,
      "t_yoyakuhyo_id": this.yoyakuData.t_yoyakuhyo_id
    }
    this.personService.getPersonYoyaku(params)
    .subscribe((res: Response) => {
        let startQuestionList = [];
        if (res["fuel_status"] == "OK") {
          this.dataList = res["fuel_results"];
          this.isLoaded = true;
        } else if (res["fuel_status"] == "NG") {
            this.commonService.modalOpens(res["fuel_message"], modalresult => { });
        } else {
            this.commonService.modalOpens(11003, modalresult => { });
        }
    }, error => {
        this.commonService.modalOpens(error, modalresult => { });
    });
  }
  OK(): void {
    this.ret.status = "OK";
    this.activeModal.close(this.ret);
  }
}



// WEBPACK FOOTER //
// ./src/app/a0108-person/yoyaku-property-model.component.ts